import { defineMessages } from 'react-intl'

export default defineMessages({
  english: 'English',
  german: 'German'
})
